import AddBoxIcon from "@mui/icons-material/AddBox";
import WorkIcon from "@mui/icons-material/Work";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Guid from "_shared/guids/guid";
import Name from "_shared/names/name";
import SelectedVendorTeamLeader from "work/work-agreements/teams/vendor-team/selection/selected-vendor-team-leader/selected-vendor-team-leader";
import SelectedVendorTeam from "work/work-agreements/teams/vendor-team/selection/selected-vendor-team/selected-vendor-team";

const StyledButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
  marginBottom: theme.spacing(1),
  marginLeft: theme.spacing(2),
  minWidth: theme.spacing(30),
}));

export type DirectProposalButtonProps = {
  action: "create" | "request";
  targetTeamId?: Guid;
  targetUserId?: Guid;
  targetEntityId?: Guid;
  targetName?: Name;
  targetHasSigningAuthority?: boolean;
  useStyledButton?: boolean;
  targetTeamName?: string;
  onClick: (targetUrl: URL) => void;
};

export default function DirectProposalButton(props: Readonly<DirectProposalButtonProps>) {
  const {
    action,
    targetTeamId,
    targetUserId,
    targetEntityId,
    targetName,
    useStyledButton,
    targetTeamName,
    targetHasSigningAuthority,
    onClick,
  } = props;

  if (!targetName) {
    throw new Error("Target name is required when targeting a team leader.");
  }

  const handleClick = () => {
    if (targetTeamId) {
      const team = new SelectedVendorTeam(targetTeamId, targetTeamName);
      const result = team.generateTargetUrl(action, globalThis.location);
      onClick(result);
    } else if (targetUserId && targetEntityId) {
      if (!targetHasSigningAuthority) return;
      const rep = new SelectedVendorTeamLeader({
        userId: targetUserId,
        legalEntityId: targetEntityId,
        hasSigningAuthority: targetHasSigningAuthority,
        name: targetName,
      });
      const result = rep.generateTargetUrl(action, globalThis.location);
      onClick(result);
    }
  };

  return (
    <>
      {useStyledButton && (
        <StyledButton
          variant="outlined"
          startIcon={action === "create" ? <AddBoxIcon /> : <WorkIcon />}
          onClick={handleClick}
        >
          {action === "create" ? "Create Proposal" : "Request Proposal"}
        </StyledButton>
      )}
      {!useStyledButton && (
        <Button color="primary" startIcon={action === "create" ? <AddBoxIcon /> : <WorkIcon />} onClick={handleClick}>
          {action === "create" ? "Create Proposal" : "Request Proposal"}
        </Button>
      )}
    </>
  );
}
